import { ref } from 'vue';

const LOCAL_STORAGE_VERSION_KEY = 'localStorageVersion';
const STORAGE_KEYS_TO_RESET: string[] = [`courseProgress`, `courseStatus`];
const FULLSCREEN_ROUTES = [
  'welcome',
  'welcome-campaign',
  'intro',
  'about',
  'sprachzeitung',
  'periodico',
  'giornale',
  'journal',
  'jornal',
  'gazeta',
  'gazeta-ru',
  'newspaper',
  'baozhi',
  'ki-sprachlehrer',
  'vokabeltrainer',
  'digitales-woerterbuch',
  'ai-language-tutor',
  'profesor-ia-idiomas',
  'professeur-ia-langues',
  'insegnante-ia-lingue',
  'professor-ia-idiomas',
  'ii-repetitor-ru',
  'nauczyciel-ai',
  'digital-dictionary',
  'diccionario-digital',
  'dictionnaire-numerique',
  'dizionario-digitale',
  'dicionario-digital',
  'cifrovoy-slovar-ru',
  'cyfrowy-slownik',
  'vocabulary-trainer',
  'entrenador-de-vocabulario',
  'entraineur-de-vocabulaire',
  'allenatore-di-vocabolario',
  'treinador-de-vocabulario',
  'slovarnyy-trenazher-ru',
  'trener-slownictwa',
  'natural-method',
  'natuerliche-methode',
  'metodo-natural',
  'methode-naturelle',
  'metodo-naturale',
  'aprendizado-natural',
  'estestvennyy-metod-ru',
  'metoda-naturalna',
  'ziran-jiaoxuefa',
  'reading-practice',
  'leseuebung',
  'practica-de-lectura',
  'pratique-de-lecture',
  'pratica-di-lettura',
  'pratica-de-leitura',
  'cwiczenia-czytania',
  'praktika-chteniya-ru',
  'yuedu-lianxi-zh'
];

export default () => {
  const APP_VERSION = 'main__$(date +%s)';
  const initDone = ref(false);
  const introDone = ref(false);
  const localStorageVersion = ref(1);

  const setLocalStorageVersion = () => {
    localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, localStorageVersion.value.toString());
  };
  const resetLocalStorage = () => {
    STORAGE_KEYS_TO_RESET.forEach((k) => localStorage.removeItem(k));
  };
  const verifyLocalStorageVersion = () => {
    const stored = localStorage.getItem(LOCAL_STORAGE_VERSION_KEY);
    if (stored) {
      const storedInt = parseInt(stored);
      if (storedInt < localStorageVersion.value) {
        resetLocalStorage();
      }
    } else {
      resetLocalStorage();
    }
    setLocalStorageVersion();
  };

  const isFullscreenPage = (route: any) => {
    if (!route.name) return false;
    // Spoke landing pages (e.g. "nachrichten-auf-englisch") are generated at
    // build time from landingSeoSpokes.json (see router/spokeRoutes.ts) - too
    // many (~576) to hand-list here like the hub routes below. Every spoke
    // route carries meta.group and only spoke routes do, so it's a reliable
    // structural check instead of enumerating route names.
    if (route.meta?.group) return true;
    return FULLSCREEN_ROUTES.includes(route.name as string);
  };

  return {
    state: { initDone, introDone },
    consts: { APP_VERSION },
    funcs: { verifyLocalStorageVersion, isFullscreenPage }
  };
};
